/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/Store/AzureSubscriptionAuthStore" />
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { StoreBase } from "DistributedTask/Flux/Store";
import { IKubernetesCluster } from "DistributedTask/Common/AzureResourcesService/AzureResourceContracts";
import { AzureSubscriptionAuthActions } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/Actions/AzureSubscriptionAuthActions";
import { AzureSubscriptionAuthKeys } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/KubernetesEndpointConstants";

export interface IAzureSubscriptionAuthStoreState {
    aksClustersList: any[];
    namespacesList: string[];
    fetchingMoreClusters: boolean;
    fetchingMoreNamespaces: boolean;
    accessToken: string;
    errorMessage: string;
    serverUrl: string;
}

export class AzureSubscriptionAuthStore extends StoreBase {
    constructor() {
        super("");
        this._state = this.getState();
    }

    public initialize(instanceId: string) {
        this._actions = ActionsHubManager.GetActionsHub<AzureSubscriptionAuthActions>(AzureSubscriptionAuthActions, instanceId);
        this._actions.updateAksClusterList.addListener(this._updateAksClusterList);
        this._actions.updateAksClusterNamespaceList.addListener(this._updateAksClusterNamespaceList);
        this._actions.resetAksClusterList.addListener(this._resetAksClusterList);
        this._actions.resetAksClusterNamespaceList.addListener(this._resetAksClusterNamespaceList);
        this._actions.setAccessToken.addListener(this._updateAccessToken);
        this._actions.fetchingMoreClusters.addListener(this._handleFetchingMoreClusters);
        this._actions.fetchingMoreNamespaces.addListener(this._handleFetchingMoreNamespaces);
        this._actions.updateErrorMessage.addListener(this._updateErrorMessage);
    }

    public disposeInternal(): void {
        this._actions.updateAksClusterList.removeListener(this._updateAksClusterList);
        this._actions.updateAksClusterNamespaceList.removeListener(this._updateAksClusterNamespaceList);
        this._actions.resetAksClusterList.removeListener(this._resetAksClusterList);
        this._actions.resetAksClusterNamespaceList.removeListener(this._resetAksClusterNamespaceList);
        this._actions.setAccessToken.removeListener(this._updateAccessToken);
        this._actions.fetchingMoreClusters.removeListener(this._handleFetchingMoreClusters);
        this._actions.fetchingMoreNamespaces.removeListener(this._handleFetchingMoreNamespaces);
        this._actions.updateErrorMessage.removeListener(this._updateErrorMessage);
    }

    public static getKey(): string {
        return AzureSubscriptionAuthKeys.StoreKey;
    }

    public getState(): IAzureSubscriptionAuthStoreState {
        if (!this._state) {
            this._state = {
                aksClustersList: [],
                namespacesList: [],
                accessToken: undefined,
                errorMessage: "",
                fetchingMoreClusters: false,
                fetchingMoreNamespaces: false,
                serverUrl: ""
            };
        }

        return this._state;
    }

    private _updateAccessToken = (accessToken: string) => {
        this._state.accessToken = accessToken;
        this.emitChanged();
    }

    private _updateAksClusterList = (clusters: IKubernetesCluster[]) => {
        this._state.aksClustersList = this._state.aksClustersList.concat(clusters);
        this.emitChanged();
    }

    private _updateAksClusterNamespaceList = (namespaces: string[]) => {
        this._state.namespacesList = this._state.namespacesList.concat(namespaces);
        this.emitChanged();
    }

    private _resetAksClusterList = () => {
        this._state.aksClustersList = [];
        this._state.namespacesList = [];
        this.emitChanged();
    }

    private _resetAksClusterNamespaceList = () => {
        this._state.namespacesList = [];
        this.emitChanged();
    }

    private _handleFetchingMoreClusters = (fetchingMoreClusters: boolean) => {
        this._state.fetchingMoreClusters = fetchingMoreClusters;
        this.emitChanged();
    }

    private _handleFetchingMoreNamespaces = (fetchingMoreNamespaces: boolean) => {
        this._state.fetchingMoreNamespaces = fetchingMoreNamespaces;
        this.emitChanged();
    }

    private _updateErrorMessage = (message: string) => {
        this._state.errorMessage = message;
        this.emitChanged();
    }

    private _state: IAzureSubscriptionAuthStoreState;
    private _actions: AzureSubscriptionAuthActions;
}
